import styled from 'styled-components';

export const VideoContainer = styled.div`
  width: 15rem;
  height: 9rem;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.drawerElement};
`;
